<template>
    <div class="regex-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" />
            <span class="material-icons"> search </span>
        </div>
        <div class="entity-list">
            <div class="entity-select">
                <div class="text-uppercase caption">{{ $t("chatbotv2.regexTemplates") }}</div>
                <div
                    class="picker-item"
                    v-for="entity of regexList"
                    @click="pick(entity.regex)"
                    :class="{ active: defaultSelected === entity.regex }"
                >
                    <span class="name">{{ entity.description }} </span>
                    <span class="description">
                        {{ entity.example }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EntityTypes } from "../../../palatteEnums";
import { mapState } from "vuex";

export default {
    name: "RegexPicker",
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            regexList: [
                {
                    regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
                    description: "Genel email adresi formatı.",
                    example: "ornek@domain.com",
                },
                {
                    regex: "\\(0\\d{3}\\) \\d{3} \\d{2} \\d{2}",
                    description: "Türkiye yerel telefon numarası formatı.",
                    example: "(0123) 456 78 90",
                },
                {
                    regex: "\\(05\\d{2}\\) \\d{3} \\d{2} \\d{2}",
                    description: "Türkiye cep telefonu numarası formatı.",
                    example: "(0500) 123 45 67",
                },
                {
                    regex: "\\d{11}",
                    description: "11 haneli T.C. Kimlik numarası.",
                    example: "12345678901",
                },
                {
                    regex: "\\d{2} [A-Z]{1,3} \\d{2,4}",
                    description: "Türkiye araç plaka formatı.",
                    example: "34 ABC 123",
                },
                {
                    regex: "\\d{5}",
                    description: "5 haneli Türkiye posta kodu.",
                    example: "12345",
                },
                {
                    regex: "\\d{10}",
                    description: "10 haneli vergi kimlik numarası.",
                    example: "1234567890",
                },
                {
                    regex: "\\d{16}",
                    description: "16 haneli banka hesap numarası.",
                    example: "1234123412341234",
                },
                {
                    regex: "TR\\d{2} \\d{4} \\d{4} \\d{4} \\d{4} \\d{4} \\d{2}",
                    description: "Türkiye IBAN formatı.",
                    example: "TR00 1234 1234 1234 1234 1234 00",
                },
                {
                    regex: "(İstanbul|Ankara|İzmir|Bursa|Antalya|Adana|Konya|Gaziantep|Mersin|Kayseri|...)",
                    description: "Büyük Türk şehirlerinin isimleri.",
                    example: "İstanbul",
                },
                {
                    regex: " \\d{11}",
                    description: "Türkiye sürücü belgesi numarası.",
                    example: "12345678901",
                },
                {
                    regex: " \\d{11}",
                    description: "11 haneli sağlık sigortası numarası.",
                    example: "12345678901",
                },
                {
                    regex: "[A-Z]{2}\\d{7}",
                    description: "Türkiye pasaport numarası.",
                    example: "AB1234567",
                },
                {
                    regex: ".+ Mah\\. .+ Cad\\. No:\\d+, \\d{5} .+, Türkiye",
                    description: "Türkiye adres formatı.",
                    example: "Örnek Mah. Örnek Cad. No:123, 12345 İstanbul, Türkiye",
                },
                {
                    regex: "\\d{2}[A-Z]{1,3}\\d{2,4}",
                    description: "Türkiye lisans plakaları.",
                    example: "34 ABC 123",
                },
                {
                    regex: "\\d{9}",
                    description: "9 haneli üniversite öğrenci numarası.",
                    example: "123456789",
                },
                {
                    regex: "\\d{10}",
                    description: "İş yeri sicil numarası.",
                    example: "1234567890",
                },
                {
                    regex: "\\d{2,4}",
                    description: "Demiryolu tren numarası.",
                    example: "1234",
                },
                {
                    regex: "\\d{8,12}",
                    description: "Su faturası hesap numarası.",
                    example: "12345678",
                },
                {
                    regex: "\\d{7,10}",
                    description: "Elektrik faturası müşteri numarası.",
                    example: "1234567",
                },
                {
                    regex: "\\d{4}-\\d{2}-\\d{2}",
                    description: "ISO tarih formatı (YYYY-MM-DD).",
                    example: "2023-12-31",
                },
                {
                    regex: "\\d{2}/\\d{2}/\\d{4}",
                    description: "ABD tarih formatı (MM/DD/YYYY).",
                    example: "12/31/2023",
                },
                {
                    regex: "\\d{2}\\.\\d{2}\\.\\d{4}",
                    description: "Avrupa tarih formatı (DD.MM.YYYY).",
                    example: "31.12.2023",
                },
                {
                    regex: "\\d{4}/\\d{2}/\\d{2}",
                    description: "Doğu Asya tarih formatı (YYYY/MM/DD).",
                    example: "2023/12/31",
                },
                {
                    regex: "\\d{1,2}-[A-Za-z]{3}-\\d{4}",
                    description: "İngilizce kısaltılmış ay ismiyle tarih formatı (DD-MMM-YYYY).",
                    example: "31-Dec-2023",
                },
                {
                    regex: "\\b\\d{1,3}(\\.\\d{1,3}){3}\\b",
                    description: "IPv4 IP adresi formatı.",
                    example: "192.168.1.1",
                },
                {
                    regex: "@[A-Za-z0-9_]+",
                    description: "@ ile başlayan kullanıcı adları.",
                    example: "@kullaniciadi",
                },
                {
                    regex: "rgb\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\)",
                    description: "RGB renk değeri formatı.",
                    example: "rgb(255, 0, 0)",
                },
                {
                    regex: "\\d{2}/\\d{2}",
                    description: "Kredi kartı son kullanma tarihi formatı (MM/YY).",
                    example: "12/21",
                },
                {
                    regex: "\\b\\d{4}[- ]?\\d{4}[- ]?\\d{4}[- ]?\\d{4}\\b",
                    description: "Kredi kartı numarası formatı.",
                    example: "1234 5678 9123 4567",
                },
                {
                    regex: "\\d{3}",
                    description: "Kredi kartı CVC numarası (3 haneli güvenlik kodu).",
                    example: "123",
                },
                {
                    regex: "\\d{6}",
                    description: "6 haneli PIN kodu.",
                    example: "123456",
                },
                {
                    regex: "[A-Z]{2}",
                    description: "Ülke ISO kodu (2 harfli).",
                    example: "TR",
                },
                {
                    regex: "\\b([01]?[0-9]|2[0-3]):[0-5][0-9]\\b",
                    description: "Saat ve dakika formatı (HH:MM, 24 saat formatında).",
                    example: "13:45",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            userEntities: (state) => state.CB.userEntities,
        }),
    },
};
</script>

<style lang="scss">
.regex-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .entity-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 0;
    }

    .entity-select {
        .caption {
            margin-bottom: 10px;
            padding: 0 15px;
            color: #9ba6b3;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 15px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons {
            color: #647283;
            font-size: 15px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 20px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
